import styled, {createGlobalStyle}  from "styled-components";

export const GlobalModalStyle = createGlobalStyle`
  .ModalForgetPassword .ant-modal-body,
  .DividerCenterSM .ant-modal-body {
    padding: 24px 24px 12px 24px;
  }
  .ModalForgetPassword.ant-modal .ant-modal-footer {
    display: flex;
	  justify-content: center;
  }
  .ModalAddAlarmMail .ant-checkbox-group .ant-checkbox-wrapper span {
    color: var(--font-45);
  }
  .ModalAddAlarmMail .ant-checkbox-group .ant-checkbox-wrapper.ant-checkbox-wrapper-checked span {
	  color: var(--font-85);
  }
  /* 统一告警邮箱弹窗中提示图标与文案的垂直对齐，避免图标基线偏移。 */
  .ModalAddAlarmMail .alarm-mail-warning-text {
    display: inline-flex;
    align-items: center;
  }
  .ModalAddAlarmMail .alarm-mail-warning-space {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .ModalAddAlarmMail .alarm-mail-warning-space .ant-space-item {
    display: inline-flex;
    align-items: center;
  }
  .ModalAddAlarmMail .alarm-mail-warning-space .anticon {
    display: inline-flex;
    align-items: center;
    line-height: 1;
  }
  .ModalUserCenter .ant-modal-body,
  .ModalEdit .ant-modal-body,
  .ModalAdd .ant-modal-body,
  .ModalAddPs .ant-modal-body {
    padding: 0;
  }

  .ModalDataSet .ant-checkbox-group {
  	display: flex;
  	flex-direction: row;
  	flex-wrap: wrap;
  	box-sizing: border-box;
  	gap: 4px;
  }
  .ModalDataSet .ant-checkbox-group .ant-checkbox-group-item {
  	margin-right: 0;
  	min-width: calc(33.333333% - 4px) !important;
  }
  .ModalDataSet .ant-checkbox-wrapper.checkBoxAll {
  	padding: 0 0 2px 0;
  	margin: 0 0 12px 0;
  	border-bottom: 1px solid var(--border-default-color);
  	box-shadow: 0 8px 8px -8px var(--box-shadow-color) !important;
  	box-sizing: border-box;
  	width: 100%;
  }
  .ModalDataSet .ant-checkbox-wrapper.checkBoxAll .ant-checkbox-wrapper {
  	display: inline;
  }
  .ModalDataSet .ant-checkbox-wrapper.checkBoxAll>span {
  	font-weight: 600 !important;
  }

  .ModalAlarmInfo {
    .ant-modal-body {
    	min-height: var(--wh-466);
    }
    .ant-modal-close {
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	height: 64px;
    	top: 10px !important;
    }
  }

  .ModalDividerCenterSM .ant-modal-body {
    max-height: var(--wh-466);
    margin: 0 6px 0 8px;/** 无root 元素，无法获取 */
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;/** 无root 元素，无法获取 */
      margin-right: 6px;/** 无root 元素，无法获取 */
      background: transparent;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border: none;
      box-shadow: none;
      margin-bottom: 15px;/** 无root 元素，无法获取 */
    }
    &::-webkit-scrollbar-thumb {
      border: none;
    }
    &::-webkit-scrollbar-corner {
      background: transparent;
    }
  }
  

  .ant-modal {
    width: calc(100% - 20px) !important;
  }
  .ModalNormal {
  	max-width: 980px;
  }
  .ModalDefault {
  	max-width: 768px;
  }
  .ModalSmall {
  	max-width: 600px;
  }
  .ModalConfirm {
  	max-width: 420px;
  }
  .ModalConfirm .ant-modal-body {
  	padding: 20px 24px;
  	font-size: var(--fontsize-14);
  	color: var(--font-85);
  	line-height: 1.6;
  }
  .ModalLarge {
  	max-width: 1200px;
  }
    .ant-modal-content { 
      border-radius: 30px;
    }
      .ant-modal-header {
      	border-radius: 30px 30px 0 0;
      	overflow: hidden;
        .ant-modal-title {
        	font-size: var(--fontsize-16);
        	font-weight: 600;
          .ant-space {
          	gap: 0 !important;
            .ant-breadcrumb {
            	font-weight: 100;
            }
          }
        }
      }
      .ant-modal-body { 
        .ant-divider-horizontal.ant-divider-with-text {
        	margin: 8px 0;
        }
      }
      .ant-modal-footer {
      	overflow: hidden;
      	display: flex;
      	justify-content: flex-end;
      	text-align: right;
      	padding: 10px 24px !important;
      	border-radius: 0 0 30px 30px !important;
      	gap: 8px;
      	height: 55px;
        .ant-btn {
          display: flex;
	        flex-direction: row;
	        justify-content: center;
	        align-items: center;
	        min-width: 138px !important;
	        margin: 0 !important;
        }
      }
  @media (max-width:576px) {
    .ModalEdit .ant-typography {
	  	text-align: center !important;
	  }
    .ModalUserCenter .ant-modal-footer,
    .ModalEdit .ant-modal-footer,
    .ModalAdd .ant-modal-footer,
    .ModalLog .ant-modal-footer,
    .ModalAddPs .ant-modal-footer,
    .ModalAddThreshold .ant-modal-footer {
      justify-content: center;
		  text-align: center;
    }

    .ModalUserCenter .ant-modal-header .ant-modal-title,
    .ModalEdit .ant-modal-header .ant-modal-title,
    .ModalAdd .ant-modal-header .ant-modal-title,
    .ModalLog .ant-modal-header .ant-modal-title,
    .ModalAddPs .ant-modal-header .ant-modal-title,
    .ModalAddThreshold .ant-modal-header .ant-modal-title {
	  	justify-content: center;
	  	text-align: center;
	  }

    .ModalDataSet .ant-checkbox-group .ant-checkbox-group-item {
	  	width: calc(50% - 8px) !important;
	  }
  }

  @media (max-width:576px) {
  	.ant-modal.DividerCenterSM .ant-modal-body,
  	.ant-modal.DividerCenterSM .ant-modal-footer {
  		text-align: center !important;
  		transition: var(--transition-slow);
  	}
  	.ant-modal .ant-typography {
  		padding: 0 !important;
  	}
  	.DividerCenterSM .ant-divider-inner-text {
  		display: flex;
  		justify-content: center !important;
  		flex-wrap: wrap !important;
  		padding-left: 16px !important;
  	}
  	.DividerCenterSM .ant-divider.DividerWarning .ant-divider.ant-divider-vertical,
  	.DividerCenterSM .ant-divider.DividerWarning .ant-divider.DividerWithWarning {
  		display: none;
  	}
  	.DividerCenterSM .ant-divider.ant-divider-with-text::before,
  	.DividerCenterSM .ant-divider.ant-divider-with-text::after {
  		top: 50% !important;
  		width: 50% !important;
  	}
  }

  @media (max-width:768px) {
  	.ModalAddThreshold .ant-modal-footer,
  	.ModalAddThreshold .ant-modal-header .ant-modal-title {
  		justify-content: center;
  		text-align: center;
  	}
  }
`;
